module.exports = __webpack_public_path__ + "img/intelbras.8a40bda2.svg";